import ipdStatement from '@/services/utils/pdf/ipdStatement';
import handleBarcode from "@/services/modules/barcode";
import { useStore } from "vuex";
import useDate from '@/services/utils/day';

const ipdStatementHelper = () => {
    const { exportToPDF } = ipdStatement();
    const { fetchBarcode } = handleBarcode();
    const store = useStore();
    const { formatDate } = useDate();

    const generatePdf = async (company, patientDetails, service, receiptGenerals, total, isDentalOs = false) => {
        const userName = store.state.user.user.name;
        let qrcodeData = JSON.stringify({
            ref_no: patientDetails.admission_no,
            ref_date: patientDetails.admission_date,
            created_by: userName,
            created_date_time: formatDate(new Date())
        })

        var barCodeQuery = `?code=${patientDetails.patient.patient_id}&qrcode=${qrcodeData}`;

        try {
            const res = await fetchBarcode(barCodeQuery);
            const barcode = res.barcode;
            const qrcode = res.qrcode;

            exportToPDF(company, patientDetails, service, receiptGenerals, total, userName, barcode, qrcode, isDentalOs);
        } catch (e) {
            console.log(e);
        }
    }

    return{
        generatePdf
    }
}

export default ipdStatementHelper;